import _objectSpread from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { previewDataInterface } from '@/api/systemData/dataInterface'
import request from '@/utils/request';
export default {
  name: 'PopupSelect',
  props: {
    value: {
      default: ''
    },
    interfaceId: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    // 请求接口方式默认POST
    strmethod: {
      type: String,
      default: 'POST'
    },
    propsValue: {
      type: String,
      default: ''
    },
    columnOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    // 搜索条件
    SearchKey: {
      type: String,
      default: ''
    }
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  data: function data() {
    return {
      checkedTxtt: '',
      listQuery: {
        currentPage: 1,
        pageSize: 20
      },
      total: 0,
      list: [],
      filteredList: [],
      innerValue: '',
      keyword: '',
      checked: '',
      checkedTxt: '',
      listLoading: false,
      visible: false,
      refreshDataList: []
    };
  },
  watch: {
    value: function value(val) {
      this.setDefault();
    }
  },
  computed: {
    propsLabel: function propsLabel() {
      return this.columnOptions[0].value;
    }
  },
  created: function created() {
    this.getData();
    // this.initData()
  },
  methods: {
    getData: function getData() {
      var _this = this;
      if (!this.interfaceId) return;
      this.listLoading = true;
      var _query = _objectSpread({}, this.listQuery);
      var query = {};
      for (var key in _query) {
        if (Array.isArray(_query[key])) {
          query[key] = _query[key].join();
        } else {
          query[key] = _query[key];
        }
      }
      // query.WoId=this.keyword
      // query[this.SearchKey] = this.keyword.trim()
      request({
        url: this.interfaceId,
        method: this.strmethod,
        data: {
          currentPage: this.listQuery.currentPage,
          pageSize: this.listQuery.pageSize,
          text: this.keyword
        }
      }).then(function (res) {
        _this.filteredList = res.data.list;
        _this.listLoading = false;
        _this.total = res.data.pagination.total;
        _this.setDefault();
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    // getData() {
    //   if (!this.interfaceId) return
    //   this.listLoading = true
    //   previewDataInterface(this.interfaceId)
    //     .then(res => {
    //       console.log(res)
    //       this.list = res.data
    //       this.filteredList = this.list
    //       this.listLoading = false
    //       this.setDefault()
    //     })
    //     .catch(() => {
    //       this.listLoading = false
    //     })
    // },
    search: function search() {
      this.getData();
      // if (!this.keyword) {
      //   this.filteredList = this.list
      //   return
      // }
      // this.filteredList = this.list.filter(o =>
      //   this.columnOptions.some(
      //     option =>
      //       option.value &&
      //       o[option.value] &&
      //       o[option.value].indexOf(this.keyword) > -1
      //   )
      // )
    },
    reset: function reset() {
      this.keyword = '';
      this.filteredList = this.list;
    },
    refresh: function refresh() {
      this.keyword = '';
      this.getData();
    },
    openDialog: function openDialog() {
      if (this.disabled) return;
      this.keyword = '';
      this.checked = this.value;
      this.visible = true;
      if (!this.list.length) {
        this.getData();
      } else {
        this.filteredList = this.list;
      }
    },
    clear: function clear() {
      this.checked = '';
      this.innerValue = '';
      this.$emit('input', this.checked);
      this.$emit('change', this.checked);
      this.$emit('refreshDataList', []);
    },
    select: function select() {
      if (!this.checked) return;
      this.innerValue = this.checkedTxt;
      this.$emit('input', this.checked);
      this.$emit('change', this.checked);
      this.$emit('getName', this.checkedTxtt);
      // this.$emit("refreshDataList", this.refreshDataList);
      this.visible = false;
    },
    rowClick: function rowClick(row) {
      // this.refreshDataList = row;
      this.checked = row[this.propsValue];
      this.checkedTxt = row[this.propsLabel];
      this.checkedTxtt = row.CUSTOMERNAME;
      // console.log(row.CUSTOMERNAME)
    },
    setDefault: function setDefault() {
      if (!this.value) {
        this.$emit('refreshDataList', []);
        return this.innerValue = '';
      }
      for (var i = 0; i < this.list.length; i++) {
        if (this.list[i][this.propsValue] === this.value) {
          this.innerValue = this.list[i][this.propsLabel];
          this.$emit('refreshDataList', this.list[i]);
          break;
        }
      }
    }
  }
};